// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__3AuWj","empty":"ModalGraph_empty__IEEhd"};